import React from "react";
import CustomModal from "../../../components/common/general/CustomModal/CustomModal";
import CompleteJourney from "../../../components/journey/CompleteJourney/CompleteJourney";

const CompleteJourneyModalContainer = ({ visible, onClose, onComplete }) => {
  return (
    <CustomModal visible={visible} onRequestClose={onClose} showCloseButton={true} title="Complete Journey">
      <CompleteJourney completeButtonClick={onComplete} backButtonClick={onClose} />
    </CustomModal>
  );
};

export default CompleteJourneyModalContainer;
